import type { InterventionSectionSaveBarProps } from "./intervention-section-save-bar.type";

import { TAB_KEYS } from "@/constants/TabKeys";
import { AppSaveBar } from "@/modules/app-save-bar";

import { INTERVENTION_SECTION_SCOPE } from "./intervention-section-save-bar.constant";

export const InterventionSectionSaveBar = ({
  intervention,
  loading,
}: InterventionSectionSaveBarProps) => {
  return (
    <AppSaveBar
      scope={INTERVENTION_SECTION_SCOPE}
      tabs={[TAB_KEYS.INTERVENTIONS_DETAILS]}
      date={intervention?.updated_at}
      loading={loading}
    />
  );
};
